(() => {
  if (window.__cbxDeferredVideoInstalled) return;
  window.__cbxDeferredVideoInstalled = true;

  const videos = new Map();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 699px)');

  function eligible(video, state) {
    if (!state.visible || document.hidden || !video.getClientRects().length) return false;
    if (video.getBoundingClientRect().width === 0) return false;
    const slide = video.closest('.slideshow__slide');
    if (slide && !slide.classList.contains('is-selected')) return false;
    return !reducedMotion.matches || state.userRequested;
  }

  function update(video, state) {
    if (!eligible(video, state)) {
      video.pause();
      return;
    }
    if (!state.loaded) {
      // No live source exists before visibility/device/slide checks pass.
      video.querySelectorAll('[data-cbx-src]').forEach(source => {
        source.setAttribute('src', source.getAttribute('data-cbx-src'));
        source.removeAttribute('data-cbx-src');
      });
      if (video.hasAttribute('data-cbx-src')) {
        video.src = video.getAttribute('data-cbx-src');
        video.removeAttribute('data-cbx-src');
      }
      state.loaded = true;
      video.load();
    }
    if (video.paused) {
      video.play().catch(() => { video.controls = true; });
    }
  }

  function refresh() {
    videos.forEach((state, video) => {
      if (!video.isConnected) { dispose(video, state); return; }
      if (reducedMotion.matches) video.controls = true;
      update(video, state);
    });
  }

  function dispose(video, state) {
    observer.unobserve(video);
    state.mutations?.disconnect();
    state.abort.abort();
    video.pause();
    videos.delete(video);
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = videos.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio > 0;
      update(entry.target, state);
    });
  }, { threshold: [0, 0.01] });

  function mount(root = document) {
    root.querySelectorAll('video[data-cbx-deferred-video]').forEach(video => {
      if (videos.has(video)) return;
      const state = { visible: false, loaded: false, userRequested: false, abort: new AbortController() };
      videos.set(video, state);
      const signal = state.abort.signal;
      if (reducedMotion.matches) video.controls = true;
      video.addEventListener('pointerdown', () => {
        state.userRequested = true;
        update(video, state);
      }, { signal });
      video.addEventListener('keydown', event => {
        if (event.key === ' ' || event.key === 'Enter') {
          state.userRequested = true;
          update(video, state);
        }
      }, { signal });
      // Existing theme autoplay and slideshow callbacks may also call play().
      video.addEventListener('play', () => {
        if (!eligible(video, state)) video.pause();
      }, { signal });
      const slide = video.closest('.slideshow__slide');
      if (slide) {
        state.mutations = new MutationObserver(() => update(video, state));
        state.mutations.observe(slide, { attributes: true, attributeFilter: ['class'] });
      }
      observer.observe(video);
    });
  }

  document.addEventListener('visibilitychange', refresh);
  mobile.addEventListener('change', refresh);
  reducedMotion.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    videos.forEach((state, video) => { if (event.target.contains(video)) dispose(video, state); });
  });
  mount();
})();
